<script lang="ts" setup>
import { SliderSelectCtrl, SliderSelectOption } from "./types";
import { SLIDER_SELECT_INJECT_TOKEN } from "./variables";

const props = defineProps<SliderSelectOption>();

const sliderSelectCtrl: SliderSelectCtrl | undefined = inject(
  SLIDER_SELECT_INJECT_TOKEN,
);

sliderSelectCtrl?.registerOption(props);

onUnmounted(() => {
  sliderSelectCtrl?.unregisterOption(props);
});
</script>
<template>
  <div />
</template>
